import { applyPanel } from "./UiPanel";
import { PARCHMENT, LAYERS, DANGER } from "./theme";
import { createSwitchRow } from "./Switch";
import { playUiClick } from "../audio/sfx";
import { createModal } from "./Modal";
import { COMPANY_TYPES } from "@dein-go-city/shared";
const TYPE_LABELS = {
    service: "Dienstleistung",
    mechanic: "Handwerk",
    forestry: "Forstwirtschaft",
    agriculture: "Landwirtschaft",
    metalworks: "Metallverarbeitung",
};
let button = null;
let dom = null;
let onCreated = null;
// GameScene registers this to pan/zoom/highlight the newly-created building the same way
// clicking it in "Meine Gebäude" does — the building is server-placed, so the player has no
// idea where it landed otherwise.
export function setOnCompanyCreated(cb) {
    onCreated = cb;
}
// Last values pushed by updateAddCompanyQuota — read when the modal opens and used to gate the
// submit button, since the button/modal can be created before the first MapState arrives.
let lastLimit = null;
let lastRemaining = 0;
function inputStyle() {
    return `
    width: 100%;
    box-sizing: border-box;
    padding: 6px 8px;
    font-size: 12px;
    border-radius: 4px;
    border: 1px solid ${PARCHMENT.divider};
    background: rgba(255, 255, 255, 0.55);
    color: ${PARCHMENT.text};
    margin-bottom: 10px;
  `;
}
function labelEl(text, required = false) {
    const el = document.createElement("div");
    el.style.cssText = `font-size: 11px; font-weight: 600; color: ${PARCHMENT.textMuted}; margin-bottom: 3px;`;
    el.textContent = text;
    if (required) {
        const star = document.createElement("span");
        star.style.cssText = `color: ${DANGER}; margin-left: 3px;`;
        star.textContent = "*";
        el.appendChild(star);
    }
    return el;
}
function getDom() {
    if (dom)
        return dom;
    const overlay = document.createElement("div");
    overlay.style.cssText = `
    position: fixed;
    inset: 0;
    z-index: ${LAYERS.addCompanyBackdrop};
    background: rgba(0,0,0,0.55);
    display: none;
  `;
    overlay.addEventListener("click", () => hide());
    const panel = document.createElement("div");
    panel.style.cssText = `
    position: fixed;
    z-index: ${LAYERS.addCompanyPanel};
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 340px;
    max-height: 85vh;
    overflow-y: auto;
    font-family: ui-sans-serif, system-ui, sans-serif;
    box-shadow: 0 16px 56px rgba(0,0,0,0.55);
    padding: 16px 18px;
    display: none;
  `;
    applyPanel(panel, "beigeLight");
    const title = document.createElement("div");
    title.style.cssText = `font-size: 14px; font-weight: 700; color: ${PARCHMENT.text}; margin-bottom: 10px;`;
    title.textContent = "Eigenes Unternehmen hinzufügen";
    panel.appendChild(title);
    panel.appendChild(labelEl("Name", true));
    const titleInput = document.createElement("input");
    titleInput.type = "text";
    titleInput.placeholder = "Name des Unternehmens";
    titleInput.style.cssText = inputStyle();
    titleInput.addEventListener("input", () => updateSubmitEnabled());
    panel.appendChild(titleInput);
    panel.appendChild(labelEl("Beschreibung (optional)"));
    const descInput = document.createElement("textarea");
    descInput.rows = 2;
    descInput.placeholder = "Kurzbeschreibung";
    descInput.style.cssText = inputStyle() + "resize: vertical; height: auto;";
    panel.appendChild(descInput);
    panel.appendChild(labelEl("Link-URL", true));
    const linkInput = document.createElement("input");
    linkInput.type = "text";
    linkInput.placeholder = "https://…";
    linkInput.style.cssText = inputStyle();
    linkInput.addEventListener("input", () => updateSubmitEnabled());
    panel.appendChild(linkInput);
    panel.appendChild(labelEl("Branche"));
    const typeSelect = document.createElement("select");
    typeSelect.style.cssText = inputStyle();
    for (const t of COMPANY_TYPES) {
        const opt = document.createElement("option");
        opt.value = t;
        opt.textContent = TYPE_LABELS[t];
        typeSelect.appendChild(opt);
    }
    panel.appendChild(typeSelect);
    const internshipSwitch = createSwitchRow("Bietet Praktika an", false, () => updateSubmitEnabled(), undefined, true);
    internshipSwitch.row.style.marginBottom = "10px";
    panel.appendChild(internshipSwitch.row);
    const quotaLine = document.createElement("div");
    quotaLine.style.cssText = `font-size: 11px; color: ${PARCHMENT.textMuted}; margin-bottom: 8px;`;
    panel.appendChild(quotaLine);
    const errorLine = document.createElement("div");
    errorLine.style.cssText = `font-size: 11px; color: ${DANGER}; margin-bottom: 8px; display: none;`;
    panel.appendChild(errorLine);
    const actions = document.createElement("div");
    actions.style.cssText = "display: flex; gap: 8px; justify-content: flex-end;";
    const cancelBtn = document.createElement("button");
    cancelBtn.textContent = "Abbrechen";
    cancelBtn.style.cssText = `
    padding: 5px 12px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 4px;
    border: 1px solid ${PARCHMENT.divider};
    background: transparent;
    color: ${PARCHMENT.text};
  `;
    cancelBtn.addEventListener("click", () => {
        playUiClick();
        hide();
    });
    const submitBtn = document.createElement("button");
    submitBtn.textContent = "Hinzufügen";
    submitBtn.style.cssText = `
    padding: 5px 12px;
    font-size: 12px;
    font-weight: 600;
    border-radius: 4px;
    border: 1px solid ${PARCHMENT.highlightBorder};
    background: ${PARCHMENT.highlightBg};
    color: ${PARCHMENT.text};
  `;
    actions.append(cancelBtn, submitBtn);
    panel.appendChild(actions);
    document.body.appendChild(overlay);
    document.body.appendChild(panel);
    const modal = createModal({ panel, labelledBy: title });
    dom = {
        overlay,
        panel,
        titleInput,
        descInput,
        linkInput,
        typeSelect,
        internshipSwitch,
        quotaLine,
        errorLine,
        submitBtn,
        cancelBtn,
        modal,
    };
    return dom;
}
function updateSubmitEnabled() {
    if (!dom)
        return;
    const titleOk = dom.titleInput.value.trim().length > 0;
    const linkOk = dom.linkInput.value.trim().length > 0;
    const internshipChecked = dom.internshipSwitch.row.querySelector('input[type="checkbox"]')?.checked ?? false;
    const quotaOk = lastLimit === null || lastRemaining > 0;
    dom.submitBtn.disabled = !titleOk || !linkOk || !internshipChecked || !quotaOk;
    dom.submitBtn.style.opacity = dom.submitBtn.disabled ? "0.5" : "1";
}
function renderQuotaLine() {
    if (!dom)
        return;
    dom.quotaLine.textContent =
        lastLimit === null
            ? "Du kannst eine unbegrenzte Anzahl an Unternehmen hinzufügen."
            : lastRemaining > 0
                ? `Du kannst noch ${lastRemaining} von ${lastLimit} Unternehmen hinzufügen.`
                : "Du hast das Limit für eigene Unternehmen erreicht.";
}
function hide() {
    if (dom) {
        dom.panel.style.display = "none";
        dom.overlay.style.display = "none";
        dom.modal.close();
    }
}
// Users commonly type a bare domain ("firma.de") instead of a full URL — default to https://
// rather than rejecting it, since building.linkUrl is opened directly via window.open.
function normalizeUrl(url) {
    return /^https?:\/\//i.test(url) ? url : `https://${url}`;
}
async function submit() {
    const d = getDom();
    const title = d.titleInput.value.trim();
    const linkUrl = normalizeUrl(d.linkInput.value.trim());
    d.errorLine.style.display = "none";
    d.submitBtn.disabled = true;
    d.cancelBtn.disabled = true;
    try {
        const res = await fetch("/api/companies", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                title,
                description: d.descInput.value.trim(),
                linkUrl,
                companyType: d.typeSelect.value,
                offersInternship: true,
            }),
        });
        if (res.ok) {
            const body = (await res.json());
            playUiClick();
            hide();
            onCreated?.(body.company.id);
        }
        else {
            const body = (await res.json());
            d.errorLine.textContent = body.error ?? "Fehler beim Erstellen.";
            d.errorLine.style.display = "";
        }
    }
    catch {
        d.errorLine.textContent = "Verbindungsfehler.";
        d.errorLine.style.display = "";
    }
    finally {
        d.cancelBtn.disabled = false;
        updateSubmitEnabled();
    }
}
function show() {
    const d = getDom();
    d.titleInput.value = "";
    d.descInput.value = "";
    d.linkInput.value = "";
    d.typeSelect.selectedIndex = 0;
    d.internshipSwitch.setChecked(false);
    d.errorLine.textContent = "";
    d.errorLine.style.display = "none";
    renderQuotaLine();
    updateSubmitEnabled();
    d.submitBtn.onclick = () => void submit();
    d.overlay.style.display = "block";
    d.panel.style.display = "block";
    d.modal.open(hide);
}
// Creates the fixed bottom-right "add company" button, hidden until the first
// updateAddCompanyQuota() call reveals it (limit !== 0 for the current group).
export function mountAddCompanyButton() {
    if (button)
        return;
    button = document.createElement("button");
    button.title = "Eigenes Unternehmen hinzufügen";
    button.className =
        "fixed bottom-6 right-6 z-50 w-10 h-10 rounded-full bg-slate-800 text-slate-400 hover:bg-slate-700 flex items-center justify-center text-lg shadow-lg border-0 hidden";
    button.textContent = "🏭";
    button.addEventListener("click", () => {
        playUiClick();
        show();
    });
    document.body.appendChild(button);
}
// Called on every MapState sync — shows/hides the button and refreshes the quota text/gating.
// limit === 0 hides the button entirely (feature disabled for this group); limit === null means
// unlimited; otherwise remaining <= 0 keeps the button visible but disables submission.
export function updateAddCompanyQuota(limit, remaining) {
    lastLimit = limit;
    lastRemaining = remaining;
    button?.classList.toggle("hidden", limit === 0);
    if (dom?.panel.style.display === "block") {
        renderQuotaLine();
        updateSubmitEnabled();
    }
}
